import styled from 'styled-components';

export const StyledContainer = styled.div`
  overflow: scroll;
  padding-bottom: 50px;
  padding-top: 1em;
`;
